import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";
import i18next from "i18next";
import AppUtil from "utilities/AppUtil";

const t = i18next.getFixedT();

const _urlPrefix = "/subscription";

export const reduceCreateSubscription = createAsyncThunk(
  "subscription/reduceCreateSubscription",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      data: snakecaseKeys(params),
      method: "POST",
      successMessage: t('toast.create.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchListPagingSubscription = createAsyncThunk(
  "subscription/fetchListPagingSubscription",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchListSubscription = createAsyncThunk(
  "subscription/fetchListSubscription",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/list`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchSubscriptionDetail = createAsyncThunk(
  "subscription/fetchSubscriptionDetail",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/${params.id}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceUpdateSubscription = createAsyncThunk(
  "subscription/reduceUpdateSubscription",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/${params.id}`,
      data: snakecaseKeys(params),
      method: "PUT",
      successMessage: t('toast.update.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reducePurchaseSubscription = createAsyncThunk(
  "subscription/reducePurchaseSubscription",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/${params.subscriptionId}/company`,
      data: snakecaseKeys(params),
      method: "POST",
      successMessage: t('toast.purchase.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceCancelSubscription = createAsyncThunk(
  "subscription/reduceCancelSubscription",
  async () => {
    const result = await httpRequest({
      url: `${_urlPrefix}/request-cancel-company`,
      method: 'POST',
      successMessage: t('toast.cancel.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const reduceDeleteSubscriptionPlan = createAsyncThunk(
  "subscription/reduceDeleteSubscriptionPlan", 
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/delete`,
      data: snakecaseKeys(params),
      method: 'DELETE',
      successMessage: t('toast.delete.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  isLoading: false,
  content: [],
  pagination: {
    totalElements: 0,
    numberOfElements: 0,
    pageSize: 10,
    pageNumber: 1,
    totalPages: 0,
    page: 0
  },
  subscriptionDetail: {}
}
const slice = createSlice({
  name: "reimbursement",
  initialState: initialState,
  reducers: {

  },
  extraReducers: {
    [fetchListPagingSubscription.fulfilled]: (state, action) => {
      const { payload } = action;
      if(payload) {
        state.content = payload?.content;
        state.pagination.totalElements = payload.totalElements;
        state.pagination.numberOfElements = payload.numberOfElements;
        state.pagination.totalPages = payload.totalPages;
        state.pagination.page = payload.pageNumber;
        state.pagination = { ...state.pagination };
      }
    },
    [fetchSubscriptionDetail.fulfilled]: (state, action) => {
      const { payload } = action;
      if (payload) {
        state.subscriptionDetail = payload;
      }
    }
  }
});

export default slice.reducer;

export const getSubscriptionPage = createSelector(
  (state) => state.subscription.content,
  (content) => content
);
export const getSubscriptionDetail = createSelector(
  (state) => state.subscription.subscriptionDetail,
  (subscriptionDetail) => subscriptionDetail
);